module.exports = __webpack_public_path__ + "img/petrified_mrs_norris.779ec02e.jpg";